import { Injectable } from "@angular/core";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { ProveedorDTO } from "src/app/models/dto/proveedor.dto";

@Injectable({ providedIn: "root" })
export class ProveedoresService extends CrudService<ProveedorDTO> {
  protected controller: string = "settings/proveedores/";
}
